import type { Delivery, Draft } from '../api/draftsApi';

/** The message's first line without its Markdown: what the list row leads with. */
export function headline(text: string): string {
  const first = text.split('\n').find((l) => l.trim()) ?? '';
  return first.replace(/\*\*([^*]+)\*\*/g, '$1').replace(/^\s*[-*•]\s+/, '').replace(/\s*\[\d+\]/g, '').trim();
}

export const kindLabel = (d: Pick<Draft, 'source'>) => (d.source === 'update' ? 'Update' : 'Answer');

const MINUTE = 60_000;

/** How long a draft has waited, in the fewest characters: 5m, 5h, 2d. */
export function shortAge(iso: string, now: Date = new Date()): string {
  const minutes = Math.max(0, Math.floor((now.getTime() - new Date(iso).getTime()) / MINUTE));
  if (minutes < 60) return `${Math.max(minutes, 1)}m`;
  if (minutes < 60 * 24) return `${Math.floor(minutes / 60)}h`;
  return `${Math.floor(minutes / (60 * 24))}d`;
}

export type Progress = { done: number; total: number; label: string; failed: number };

/** How far a sent message got: read when everyone has read it, else delivered, else sent. */
export function deliveryProgress(deliveries: Delivery[]): Progress {
  const total = deliveries.length;
  const count = (...s: Delivery['status'][]) => deliveries.filter((d) => s.includes(d.status)).length;
  const failed = count('failed');
  const read = count('read');
  if (total > 0 && read === total) return { done: read, total, label: 'read', failed };
  const delivered = count('delivered', 'read');
  if (delivered > 0) return { done: delivered, total, label: 'delivered', failed };
  return { done: count('sent', 'delivered', 'read'), total, label: 'sent', failed };
}
